import React from "react";
import { SERVICES, ModalCtx, useReveal, useEditorReveal, useMeta, makeNavLink } from "./shared.jsx";
import { Crumbs, FinalCTA } from "./shared-ui.jsx";
import { HlHeading, EmHeading } from "./sections/headings.jsx";
import uslugiContent from "../content/uslugi.json";
import onasContent from "../content/o-nas.json";

// Strony: UslugiPage, ONasPage (Dlaczego my + Podejście + Technologia jako sekcje z kotwicami).
// Treść edytowalna z ../content/uslugi.json i ../content/o-nas.json (CMS /admin/uslugi, /admin/o-nas).

const noop = () => {};

// ─── USLUGI BODY ────────────────────────────────────────────────────────────
export const UslugiBody = ({ content: c = uslugiContent, navigate = noop, editor = false }) => {
  const ref = React.useRef(null);
  useReveal(ref);
  useEditorReveal(ref, editor);
  return (
    <div ref={ref}>
      {/* HERO */}
      <section className="page-hero bg-tiles container">
        <Crumbs items={[{label:"Home",href:"/"},{label:"Usługi"}]} navigate={navigate}/>
        <span className="eyebrow rv">{c.hero.eyebrow}</span>
        <h1 className="h-display rv" style={{maxWidth:"18ch"}}>
          <HlHeading before={c.hero.headingBefore} highlight={c.hero.headingHighlight} after={c.hero.headingAfter} />
        </h1>
        <p className="lead rv" style={{marginTop:28, maxWidth:"62ch"}}>{c.hero.lead}</p>
        <div className="hero-ctas rv" style={{justifyContent:"flex-start", marginTop:36}}>
          <button className="lc-btn lc-btn-ghost lc-btn-lg" onClick={() => navigate("/kontakt")}>
            {c.hero.cta} <span className="lc-btn-arr">↗</span>
          </button>
        </div>
      </section>

      {/* LISTA USŁUG (z shared SERVICES) */}
      <section className="sec container">
        <div className="section-title-row">
          <div>
            <span className="eyebrow">{c.list.eyebrow}</span>
            <h2 className="h2 rv">{c.list.headingBefore}<strong style={{fontWeight:600,color:"#fff"}}>{c.list.headingStrong}</strong></h2>
          </div>
          <span className="muted" style={{fontFamily:"var(--font-display)",fontSize:11,letterSpacing:".14em",textTransform:"uppercase"}}>{c.list.count}</span>
        </div>
        <ul className="svc-list">
          {SERVICES.map(s => {
            const link = makeNavLink(navigate);
            return (
            <li key={s.slug} className="svc-item-li">
              <a className="svc-item rv" {...link(`/uslugi/${s.slug}`)}>
                <span className="svc-k">{s.k}</span>
                <div>
                  <h3 className="svc-name">{s.name}</h3>
                  <p className="svc-desc">{s.desc}</p>
                </div>
                <span className="svc-meta">{s.meta}</span>
                <span className="svc-arr">↗</span>
              </a>
            </li>
            );
          })}
        </ul>
      </section>

      {/* JAK PRACUJEMY */}
      <section className="sec" style={{background:"#0f1012"}}>
        <div className="container">
          <div className="sec-head rv">
            <span className="eyebrow">{c.proces.eyebrow}</span>
            <h2 className="h2"><EmHeading before={c.proces.headingBefore} em={c.proces.headingEm} after={c.proces.headingAfter} /></h2>
          </div>
          <div className="process-grid">
            {(c.proces.cards || []).map(s => (
              <div key={s.k} className="process-card rv">
                <span className="process-k">{s.k}</span>
                <h3 className="process-t">{s.t}</h3>
                <p className="process-d">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA navigate={navigate}/>
    </div>
  );
};

const UslugiPage = ({ navigate }) => {
  useMeta({ title: uslugiContent.meta.title, description: uslugiContent.meta.description });
  return <UslugiBody navigate={navigate} />;
};


// ─── Cross-channel dashboard (legacy table layout, used elsewhere) — STAŁY MOCKUP ──
const CrossChannelDash = () => {
  const channels = [
    { name: "Google Ads",  spend: "89 100",  roas: "5.2x", conv: "1 240", color: "#4285F4" },
    { name: "Meta Ads",    spend: "64 200",  roas: "4.4x", conv: "890",   color: "#0866FF" },
    { name: "Allegro Ads", spend: "33 940",  roas: "4.8x", conv: "510",   color: "#FF5A00" },
  ];
  return (
    <div className="ccd-wrap rv">
      <div className="ccd-frame">
        <div className="ccd-head">
          <div className="ccd-dots">
            {[0,1,2].map(i => <span key={i} className="ccd-dot" />)}
          </div>
          <span className="ccd-url">letscommerce.dashboard / cross-channel · 30 dni</span>
        </div>
        <div className="ccd-body">
          <div className="ccd-summary">
            <div className="ccd-stat"><span className="ccd-stat-l">// TOTAL SPEND</span><span className="ccd-stat-v">187 240 PLN</span></div>
            <div className="ccd-stat"><span className="ccd-stat-l">// BLENDED ROAS</span><span className="ccd-stat-v">4.85x</span></div>
            <div className="ccd-stat"><span className="ccd-stat-l">// CONVERSIONS</span><span className="ccd-stat-v">2 640</span></div>
            <div className="ccd-stat"><span className="ccd-stat-l">// REVENUE</span><span className="ccd-stat-v">907 614 PLN</span></div>
          </div>
          <div className="ccd-table">
            <div className="ccd-row ccd-row-head"><span>KANAŁ</span><span>SPEND</span><span>ROAS</span><span>CONV.</span><span>SHARE</span></div>
            {channels.map(c => {
              const cs = parseFloat(c.spend.replace(/\s/g, ""));
              const share = Math.round((cs / 187240) * 100);
              return (
                <div key={c.name} className="ccd-row">
                  <span className="ccd-channel"><span className="ccd-channel-dot" style={{ background: c.color }} />{c.name}</span>
                  <span className="ccd-mono">{c.spend} PLN</span>
                  <span className="ccd-mono ccd-good">{c.roas}</span>
                  <span className="ccd-mono">{c.conv}</span>
                  <span className="ccd-bar"><span className="ccd-bar-fill" style={{ width: `${share}%`, background: c.color }} /><span className="ccd-bar-val">{share}%</span></span>
                </div>
              );
            })}
          </div>
          <div className="ccd-foot">
            <span className="ccd-foot-l">// trend ostatnie 30 dni</span>
            <svg className="ccd-spark" width="100%" height="40" viewBox="0 0 400 40" preserveAspectRatio="none">
              <polyline fill="none" stroke="var(--brand)" strokeWidth="2" points="0,28 30,24 60,30 90,20 120,22 150,15 180,18 210,12 240,16 270,10 300,14 330,8 360,11 400,6"/>
              <polyline fill="none" stroke="var(--green)" strokeWidth="1.5" strokeDasharray="3 3" opacity=".6" points="0,32 30,30 60,33 90,28 120,30 150,26 180,28 210,24 240,26 270,22 300,24 330,20 360,22 400,19"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};


// ─── CrossChannelGrid — 3-column comparative dashboard (Marketing hero) — STAŁY MOCKUP ──
const CrossChannelGrid = () => {
  const channels = [
    { name: "Google Ads", color: "#4285F4", kpis: [["SPEND", "89.1k PLN"], ["ROAS", "5.2x"], ["CONV.", "1 240"]], spark: "0,18 20,16 40,15 60,12 80,14 100,10 120,11 140,8 160,9 180,6" },
    { name: "Meta Ads", color: "#0866FF", kpis: [["SPEND", "64.2k PLN"], ["ROAS", "4.4x"], ["CONV.", "890"]], spark: "0,16 20,14 40,15 60,11 80,12 100,9 120,10 140,7 160,8 180,5" },
    { name: "Allegro Ads", color: "#FF5A00", kpis: [["SPEND", "33.9k PLN"], ["ROAS", "4.8x"], ["CONV.", "510"]], spark: "0,17 20,15 40,16 60,13 80,11 100,12 120,9 140,10 160,7 180,5" },
  ];
  return (
    <div className="ccg-wrap rv">
      <div className="ccg-frame">
        <div className="ccg-head">
          <div className="ccg-dots">{[0,1,2].map(i => <span key={i} className="ccg-dot" />)}</div>
          <span className="ccg-url">letscommerce.dashboard / multi-channel · 30 dni</span>
        </div>
        <div className="ccg-blended">
          <div className="ccg-blended-cell"><span className="ccg-blended-l">// BLENDED SPEND</span><span className="ccg-blended-v">187 240 PLN</span></div>
          <div className="ccg-blended-cell"><span className="ccg-blended-l">// BLENDED ROAS</span><span className="ccg-blended-v">4.85x</span></div>
          <div className="ccg-blended-cell"><span className="ccg-blended-l">// REVENUE</span><span className="ccg-blended-v">907 614 PLN</span></div>
        </div>
        <div className="ccg-cols">
          {channels.map(c => (
            <div key={c.name} className="ccg-col" style={{ borderTopColor: c.color }}>
              <div className="ccg-col-head">
                <span className="ccg-col-dot" style={{ background: c.color }} />
                <span className="ccg-col-name">{c.name}</span>
              </div>
              {c.kpis.map(([l, v]) => (
                <div key={l} className="ccg-col-kpi">
                  <span className="ccg-col-kpi-l">{l}</span>
                  <span className="ccg-col-kpi-v">{v}</span>
                </div>
              ))}
              <svg className="ccg-col-spark" viewBox="0 0 180 24" preserveAspectRatio="none">
                <polyline fill="none" stroke={c.color} strokeWidth="1.5" points={c.spark}/>
              </svg>
            </div>
          ))}
        </div>
        <div className="ccg-foot">// jeden widok zamiast trzech paneli</div>
      </div>
    </div>
  );
};


// ─── O NAS BODY ─────────────────────────────────────────────────────────────
export const ONasBody = ({ content: c = onasContent, navigate = noop, editor = false }) => {
  const ref = React.useRef(null);
  useReveal(ref);
  useEditorReveal(ref, editor);

  return (
    <div ref={ref}>

      {/* 1. HERO */}
      <section className="page-hero bg-tiles container">
        <Crumbs items={[{label:"Home",href:"/"},{label:"O nas"}]} navigate={navigate}/>
        <h1 className="h-display rv"><HlHeading before={c.hero.headingBefore} highlight={c.hero.headingHighlight} after={c.hero.headingAfter} /></h1>
      </section>

      {/* 2. ZESPÓŁ */}
      <section className="sec container">
        <div className="team-grid">
          {(c.team || []).map((m) => (
            <div key={m.role} className="team-card rv">
              <div className="team-photo"><img src={m.img} alt={m.name} loading="lazy" decoding="async"/></div>
              <span className="eyebrow">{m.role}</span>
              <h3 className="team-name">{m.name}</h3>
              <p className="team-bio">{m.bio}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 3. KPI STRIP */}
      <section className="lc-stats-strip">
        <div className="container">
          <div className="lc-stats-grid rv">
            {(c.kpis || []).map(k => (
              <div key={k.l} className="lc-stats-cell">
                <span className="lc-stats-label">// {k.l}</span>
                <span className="lc-stats-value">{k.v}</span>
              </div>
            ))}
          </div>
          <span className="lc-stats-note">{c.kpisNote}</span>
        </div>
      </section>

      {/* 4. DLACZEGO MY */}
      <section id="dlaczego-my" className="sec container">
        <div className="sec-head rv">
          <span className="section-eyebrow">{c.why.eyebrow}</span>
          <h2 className="h2"><HlHeading before={c.why.headingBefore} highlight={c.why.headingHighlight} after={c.why.headingAfter} /></h2>
          <p className="sec-sub">{c.why.sub}</p>
        </div>
      </section>

      <section className="sec container">
        {(c.why.blocks || []).map((b) => (
          <div key={b.k} className="why-row">
            <div className="why-body rv">
              <div className="why-num">{b.k}</div>
              <h2 className="h2" style={{marginBottom:20}}>{b.t}</h2>
              <h3 style={{fontFamily:"var(--font-display)",fontWeight:500,fontSize:"clamp(20px,2vw,26px)",color:"#fff",letterSpacing:"-0.01em",lineHeight:1.2,margin:"0 0 18px"}}>{b.head}</h3>
              {String(b.body || "").split("\n\n").filter(Boolean).map((p, j) => <p key={j} className="lead" style={{marginBottom:14}}>{p}</p>)}
            </div>
            <div className="why-art rv">
              <img src={b.img} alt="" loading="lazy" decoding="async"/>
            </div>
          </div>
        ))}
      </section>

      {/* 5. TRZY ZASADY — id="podejscie" */}
      <section id="podejscie" className="sec container">
        <div className="sec-head rv">
          <span className="section-eyebrow">{c.zasady.eyebrow}</span>
          <h2 className="h2">{c.zasady.heading}</h2>
          <p className="sec-sub">{c.zasady.sub}</p>
        </div>
        <div className="zasady-grid">
          {(c.zasady.tiles || []).map((z, i) => (
            <div key={i} className="zasada-tile rv">
              <div className="zasada-art"><img src={z.img} alt={z.label} loading="lazy" decoding="async"/></div>
              <span className="zasada-label">// {z.label}</span>
              <h3 className="zasada-h">{z.h}</h3>
              <p className="zasada-body">{z.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 6. PORÓWNANIE */}
      <section className="sec" style={{background:"#0f1012"}}>
        <div className="container">
          <div className="sec-head rv">
            <span className="section-eyebrow">{c.compare.eyebrow}</span>
            <h2 className="h2"><HlHeading before={c.compare.headingBefore} highlight={c.compare.headingHighlight} after={c.compare.headingAfter} /></h2>
            <p className="sec-sub">{c.compare.sub}</p>
          </div>
          <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch"}}>
          <table className="compare">
            <thead><tr><th></th><th>{c.compare.colA}</th><th>{c.compare.colB}</th></tr></thead>
            <tbody>
              {(c.compare.rows || []).map((row, i) => (
                <tr key={i}>
                  <td>{row.label}</td>
                  <td><span className="cross">✕</span>{row.a}</td>
                  <td><span className="tick">✓</span>{row.b}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </section>

      {/* 7. AUTOMATYZACJA WEWNĘTRZNA — id="technologia" */}
      <section id="technologia" className="sec container">
        <div className="sec-head rv">
          <span className="section-eyebrow">{c.tech.eyebrow}</span>
          <h2 className="h2">{c.tech.heading}</h2>
          <p className="sec-sub">{c.tech.sub}</p>
        </div>
        <div className="ins-grid tech-stack-grid">
          {(c.tech.cards || []).map(card => (
            <div key={card.k} className="ins-card rv tech-card">
              <span className="ins-n">{card.k}</span>
              <h3 className="ins-t">{card.t}</h3>
              <p className="ins-b">{card.b}</p>
              <div className="ins-fx">Efekt: {card.fx}</div>
            </div>
          ))}
        </div>
      </section>

      {/* 8. CERTYFIKATY */}
      <section className="sec" style={{background:"#0f1012"}}>
        <div className="container">
          <div className="sec-head rv">
            <span className="section-eyebrow">{c.certyfikaty.eyebrow}</span>
            <h2 className="h2"><HlHeading before={c.certyfikaty.headingBefore} highlight={c.certyfikaty.headingHighlight} after={c.certyfikaty.headingAfter} /></h2>
          </div>
          <div className="pill-row" style={{gap:12}}>
            {(c.certyfikaty.badges || []).map((b, i) => (
              <span key={i} className={"ft-badge" + (b.variant ? " " + b.variant : "")}>{b.label}</span>
            ))}
          </div>
        </div>
      </section>

      {/* 9. FINAL CTA */}
      <FinalCTA navigate={navigate} title={<EmHeading before={c.finalTitle.before} em={c.finalTitle.em} after={c.finalTitle.after} />}/>

    </div>
  );
};

const ONasPage = ({ navigate }) => {
  useMeta({ title: onasContent.meta.title, description: onasContent.meta.description });
  return <ONasBody navigate={navigate} />;
};

export { UslugiPage, ONasPage, CrossChannelDash, CrossChannelGrid };
